import React from 'react';

const ESAPlanFundNoteTip = () => (
  <div className="exclude">
    Education Savings Accounts are not eligible for online transactions. Please{' '}
    <a
      href="https://www.troweprice.com/personal-investing/help/contact/index.html"
      target="_blank"
      rel="noreferrer"
      className="exclude"
    >
      contact us
    </a>{' '}
    to transact in your Education Savings Account.
  </div>
);

export default ESAPlanFundNoteTip;
